<template>
<bsp-dialog :title="$t('cost.invoice021')" :dialogVisible.sync="visible" @closeButton="closeDialog" width="1100px"><!-- 票据识别结果 -->
  <template #body v-loading="loading">
    <div class="flexTable">
      <div class="gridHead" style="width: 100%;">
        <div class="gridHeadLeft">
          <span v-html="msg2"></span>
          <el-popover
            v-if="showErrorIcon"
            popper-class="el-popover--plain"
            placement="bottom"
            width="500"
            trigger="hover">
            <i class="el-icon-warning icon-warning" slot="reference"></i>
            <el-alert :title="$t('cost.invoice022')" type="error" class="marginBottom20" :closable="false" v-if="errorList && errorList.length"><!-- 错误信息 -->
              <p class="tip-item" v-for="(item, index) in errorList" :key="`error-${ index }`">{{ index + 1 }}、{{ item }}</p>
            </el-alert>
            <el-alert :title="$t('cost.invoice023')" type="warning" :closable="false" v-if="warnList && warnList.length"><!-- 异常提示 -->
              <p class="tip-item" v-for="(item, index) in warnList" :key="`warn-${ index }`">{{ index + 1 }}、{{ item }}</p>
            </el-alert>
          </el-popover>
        </div>
        <div class="gridHeadRight">
          <el-button type="primary" @click="deleteInvoices" style="float: right;margin: 0 5px;">{{$t('cost.invoice003')}}</el-button><!-- 批量删除 -->
        </div>
  <!--      <el-form ref="searchForm" :model="searchForm"  size="small" style="padding: 0; margin-top: 0; width: 100%;">-->
  <!--        <el-row>-->
  <!--          <el-col :span="10">-->
  <!--            <el-form-item label="发票状态" label-width="30%">-->
  <!--              <el-select v-model="searchForm.tdStatusArr" style="width: 70%; margin-left: 0px;"  multiple collapse-tags placeholder="请选择">-->
  <!--                <el-option v-for="item in this.dicts.codeList['8044']" :key="item.codeItemId" :value="item.codeItemId" :label="item.codeItemName">-->
  <!--                </el-option>-->
  <!--              </el-select>-->
  <!--            </el-form-item>-->
  <!--          </el-col>-->
  <!--          <el-col :span="10">-->
  <!--            <el-form-item label="票据开具日期" label-width="30%">-->
  <!--              <el-date-picker v-model="searchForm.startDate" type="date" value-format='yyyy-MM-dd' placeholder="开始日期" style="width:40%;margin-left: 5px;" ></el-date-picker>-->
  <!--              至-->
  <!--              <el-date-picker v-model="searchForm.endDate" type="date" value-format='yyyy-MM-dd' placeholder="结束日期" style="width:40%;margin-right: 5px;" ></el-date-picker>-->

  <!--            </el-form-item>-->
  <!--          </el-col>-->
  <!--          <el-col :span="4">-->
  <!--            <el-button type="primary" size="mini" style="float: right;margin: 0 5px;" @click="handleReset">重置</el-button>-->
  <!--            <el-button type="primary" size="mini" style="float: right;margin: 0 5px;" @click="handleSearch">查询</el-button>-->
  <!--          </el-col>-->
  <!--        </el-row>-->

  <!--        <el-row>-->
  <!--          <el-col :span="24">-->
  <!--            <el-form-item label="" label-width="0%">-->
  <!--              <el-button type="primary" size="mini" @click="createTask" style="float: right;margin: 0 5px;">添加其他票据</el-button>-->
  <!--              <el-button type="primary" size="mini" @click="uploadAttach" style="float: right;margin: 0 5px;">OCR识别发票</el-button>-->
  <!--              <el-button type="primary" size="mini" @click="testFunc" style="float: right;margin: 0 5px;">测试专用按钮</el-button>-->
  <!--            </el-form-item>-->
  <!--          </el-col>-->
  <!--        </el-row>-->
  <!--      </el-form>-->
      </div>
      <bsp-grid
        class="bsp-grid"
        ref="itemListTable"
        :demoLoading.sync="demoLoading"
        :tableColumns.sync="tableColumns"
        :tableDatas.sync="tableDatas"
        @tableRefresh="tableRefresh"
        @updateColumn="updateColumn"
        @checkbox-all="selectAllEvent"
        @checkbox-change="selectChangeEvent"
        :checkbox-config="{ checkMethod: checkboxMethod, highlight: true, range: true}"
      >
        <template v-slot:discernCusIdText="{row}">
          <el-link type="primary" @click="toEditPage(row, 'view')" style = "text-overflow: ellipsis;white-space: nowrap;display:block;overflow: hidden;" >{{ row.cusName }}</el-link>
          <!--        <span>{{ discernCusMap[row.cusId]}}</span>-->
        </template>
        <template v-slot:discernStatusText="{row}">
          <span>{{ dicts.codeMap[row.status]}}</span>
        </template>
        <template v-slot:discernCheckStatusText="{row}">
          <span>{{ dicts.codeMap[row.checkStatus]}}</span>
        </template>

        <template v-slot:operation="{row}">

          <el-image class="gridOptIcon" :src="eidtIconUrl" :title="$t('cost.invoice015')" @click="editInvoice(row.id, row)" ></el-image><!-- 编辑/确认票据 -->
          <el-image class="gridOptIcon" :src="lockIconUrl" :title="$t('cost.invoice016')" v-show="row.status == '80510004'" @click="makeCloudInvoiceFolderVerify(row.id, row)" ></el-image><!-- 票据验真 -->
          <el-image class="gridOptIcon" :src="deleteIconUrl" :title="$t('cost.invoice017')" @click="deleteInvoice(row.id, row)" ></el-image><!-- 删除票据 -->

        </template>
      </bsp-grid>

      <invoice-edit ref="invoiceEdit" class="invoiceEdit" @reload="doEditSubmit"></invoice-edit>
    </div>
  </template>
</bsp-dialog>
</template>

<script>

import eidtIcon from '@/assets/img/miniuiIcon/edit_on.gif'
import deleteIcon from '@/assets/img/miniuiIcon/delete_on.gif'
import lockIcon from '@/assets/img/miniuiIcon/lock.png'
import { getUserCusList, getUserCusListZz, getAllCusList} from "@/api/sys/cus";
import {deleteCloudInvoiceFolder, getCloudCostDetailMobileList, getInvoiceFolderOrcByAttachids, makeCloudInvoiceFolderVerify} from "@/api/cost/cost";
import UploadAttach from "@/views/cost/components/UploadAttach";
import bspGrid from "@/components/bsp/bsp-grid/grid";
import BspDictsSelect from '@/components/bsp/bsp-dicts-select/bsp-dicts-select'
import { downloadFile } from '@/util/util'
import { validatenull } from "@/util/validate";
import {mapGetters} from 'vuex';
import {formatDateSubstr10, formatDateSimple} from "@/util/date_format.js"
import viewIcon from "@/assets/img/miniuiIcon/search_2.gif";
import BspDialog from "@/components/bsp/bsp-dialog/bsp-dialog";
import InvoiceEdit from "@/views/cost/costInvoiceFolder/invoiceFolderEdit";

export default {
  name: "confirmInvoiceList",
  components: { bspGrid , BspDialog, InvoiceEdit },
  props:{
    optParams: {
      type: Object,
      default: function (){
        return {
        };
      },
    },
  },
  data() {
    return {
      searchForm:{},
      searchParams: {},
      tableDatas: [],
      tableColumns: [],
      filtersData: { page: 1, limit: 100 },
      pagerConfig: {
        total: 0,
        page: 1,
        limit: 20
      },
      demoLoading: true,
      loadingImport: false,
      loadingBtn: false,
      multipleSelection: [],
      fileList : [],
      msg1: "",
      msg2: "",
      errorList: [],
      warnList: [],
      lockIconUrl : lockIcon,
      eidtIconUrl : eidtIcon,
      deleteIconUrl : deleteIcon,
      visible: false,
    };
  },
  created() {

    this.getColumn();
    // this.init();

  },
  mounted(){
    // console.log("批次号m",this.billBatch)
  },
  methods: {


    // 查询
    handleSearch() {
      this.pagerConfig.page = 1;
      this.filtersData.page = 1;
      this.searchParams = this.searchForm;
      this.getData();
    },
    handleReset() {
      this.searchForm = {};
      this.initSelectForm();
      this.pagerConfig.page = 1;
      this.filtersData.page = 1;
      this.searchParams = this.searchForm;
      this.getData();
    },

    // 获取表头
    getColumn() {
      let column = [
        {
          type: "checkbox",
          setId: "",
          width: 50,
        },{
          type: "",
          field: "invoiceHm",
          title: this.$t("cost.invoice004"), //票据号码
        },{
          type: "",
          field: "invoiceTypeTxt",
          title: this.$t("cost.invoice004"), //票据类型
        },{
          type: "",
          field: "startDate",
          title: this.$t("cost.invoice006"), //票据日期
        },{
          type: "",
          field: "includeTax",
          title: this.$t("cost.invoice007"), //票据金额
        },{
          type: "",
          field: "msg",
          title: this.$t("cost.invoice009"), //说明
        },{
          type: "",
          field: "status",
          title: this.$t("cost.invoice010"), //发票状态
          params:{slot:'discernStatusText'}
        },{
          type: "",
          field: "checkStatus",
          title: this.$t("cost.invoice011"), //验真状态
          params:{slot:'discernCheckStatusText'}
        },{
          type: this.$t("cost.invoice012"),
          field: "verifyMsg",
          title: "", //验真说明
        },{
          type: "",
          field: "",
          title: this.$t("cost.invoice013"), //操作
          minWidth : '140px',
          fixed: 'right',
          params:{slot:'operation'}
          //params:{slot:'discernShelvedFlagText'}
        }
      ];
      this.$set(this,"tableColumns",column);
    },
    init() {
      // if(this.$route.query.from){
      //   alert(this.$route.query.tdStatus);
      // }
      // var user = this.$store.state.user.userInfo;
      // this.userId = user.userId;
      // this.getData();
      if(this.optParams.ids){
        this.getData();
      }else{
        this.demoLoading = true;
        this.fileList = this.optParams.fileList;
        console.log("confirm fileList", this.fileList);
        this.getInvoiceFolderOrcByAttachids();
      }
    },

    getInvoiceFolderOrcByAttachids(){
      this.demoLoading = true;

      var attachIds = "";
      if(this.fileList != null && this.fileList.length > 0){
        for(var i = 0; i < this.fileList.length; i++){
          attachIds += this.fileList[i].attachmentId + ",";
        }
      }

      let params = {
        mainForm : {
          attachIds: attachIds,
        }
      }

      getInvoiceFolderOrcByAttachids(params)
        .then((response) => {
          this.demoLoading = false;
          console.log("getInvoiceFolderOrcByAttachids", response)
          let result = response.data;
          if(result.code == '0'){
            const { records, msg1, msg2, errorList, warnList } = result.data
            this.tableDatas = result.data.records;
            this.msg1 = result.data.msg1;
            this.msg2 = result.data.msg2;
            this.errorList = result.data.errorList;
            this.warnList = result.data.warnList;
            this.optParams.ids = result.data.ids;
          }else{
            this.$message.success(result.msg);
          }
        })
        .catch(error => {
          this.demoLoading = false;
          if(error.data && error.data.msg){
            this.$message.error(error.data.msg);
          }else{
            this.$message.error(error);
          }
        });
    },
    closeDialog () {
      this.visible = false;
      this.msg2 = "";
      this.fileList =  [];
      this.$emit('reload');
    },
    editInvoice(id, row){
      let params = {
        id: id,
        from: "invoiceList",
      }
      this.$refs.invoiceEdit.visible = true;
      this.$refs.invoiceEdit.params = params;
      this.$refs.invoiceEdit.init();
    },
    doEditSubmit() {
      this.init();
    },
    deleteInvoices() {
      if (!this.multipleSelection || this.multipleSelection.length === 0) {
        return this.$message.error(this.$t('homepage.txt027')) //至少选择一条数据
      }

      let idsArray =this.multipleSelection.map(item=> item.id)
      var ids = "";
      idsArray.forEach(id=> {
        ids += id + ",";
      })

      this.deleteInvoice(ids, null);
    },
    deleteInvoice(id, row) {

      var that = this;

      this.$confirm(this.$t("homepage.txt022") + "?", this.$t("homepage.txt017"), {//您确定要删除文件?  提示
        confirmButtonText: this.$t("homepage.txt018"), //确认
        cancelButtonText: this.$t("homepage.txt019"),//取消
        type: 'warning'
      }).then(() => {
        that.deleteCloudInvoiceFolder(id, row);
      }).catch(() => {
      });


    },
    deleteCloudInvoiceFolder(id, row){
      let params = {
        mainForm : {id : id}
      }

      deleteCloudInvoiceFolder(params)
        .then((response) => {
          this.demoLoading = false;
          let result = response.data;
          if(result.code == '0'){
            this.$message.success(this.$t('homepage.txt023')); //删除成功
            this.getData() ;
          }else{
            this.$message.success(result.msg);
          }
        })
        .catch(error => {
          this.demoLoading = false;
          console.log("error", error)
          this.$message.error(this.$t('homepage.txt024'));//请求异常！
        });

    },
    makeCloudInvoiceFolderVerify(id, row){
      this.demoLoading = true;
      let params = {
        mainForm : {id : id}
      }

      makeCloudInvoiceFolderVerify(params)
        .then((response) => {
          this.demoLoading = false;
          let result = response.data;
          if(result.code == '0'){
            this.$message.success(this.$t('homepage.txt028')); //操作成功
            this.getData() ;
          }else{
            this.$message.success(result.msg);
          }
        })
        .catch(error => {
          this.demoLoading = false;
          console.log("error", error)
          this.$message.error(this.$t('homepage.txt024'));//请求异常！
        });

    },
    // 获取数据
    getData() {
      this.demoLoading = true;

      let params = {
        ...this.filtersData,
        searchParams : {
          endDate: this.searchForm.endDate,
          startDate: this.searchForm.startDate,
          timeType: "80130001",
          useType: "0",
          ids: this.optParams.ids,
        }
      }

      getCloudCostDetailMobileList(params)
        .then((response) => {
          this.demoLoading = false;
          let result = response.data;
          if(result.code == '0'){
            this.tableDatas = result.data.records;
            this.pagerConfig.total = result.data.total;

          }else{
            this.$message.success(result.msg);
          }
        })
        .catch(error => {
          this.demoLoading = false;
          console.log("error", error)
          this.$message.error(this.$t('homepage.txt024'));//请求异常！
        });

    },
    //获取请求筛选数据/分页
    tableRefresh(filter, cal) {
      this.filtersData = filter;
      this.pagerConfig.page = filter.page;
      this.pagerConfig.limit = filter.limit;
      this.getData(cal);
    },
    updateColumn(columns) {
      //console.log(columns);
    },
    selectAllEvent({ checked, records, selection }) {
      this.multipleSelection = records;
    },
    selectChangeEvent({ checked, records }) {
      this.multipleSelection = records;
    },
    // 禁用表格复选框
    checkboxMethod({row}) {
      return true;
      //return row.discernStatus == '80130003';
    },
    doSubmit(val) {
      console.log("doSubmit", val);
    },

    isNotBlank(str){
      if(str == null || str ==undefined || str == ''){
        return false;
      }else{
        return true;
      }
    }
  },
  destroyed(){
  },
  computed: {
    ...mapGetters(['billBatch','userInfo','dicts']),
    showErrorIcon() {
      return !validatenull(this.errorList) || !validatenull(this.warnList)
    }
  }
};
</script>
<style lang="scss" scoped>
  .icon-warning {
    font-size: 18px;
    color: #C73122;
    cursor: pointer;
  }
  .tip-item {
    padding: 2px 0;
  }
</style>
